(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-editorial"]) return;
  try {
    
function setupCollectionEditions(root) {
  root.querySelectorAll('[data-collection-edition]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const toggle = section.querySelector('.edition-filter-toggle');
    const panel = section.querySelector('.edition-filters');
    panel.hidden = true;
    toggle.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
    });
    section.querySelector('[name="sort_by"]').addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    });
  });
}
setupCollectionEditions(document);
document.addEventListener('shopify:section:load', event => setupCollectionEditions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function minglangArrangeProductDetails(root=document){
  root.querySelectorAll('.ml-product__full-details .ml-product__description:not([data-layout-ready])').forEach(description=>{
    description.dataset.layoutReady='true';
    const nodes=[...description.childNodes];
    let group=null,index=0;
    for(const node of nodes){
      if(node.nodeType===1&&node.tagName==='H2'){
        group=document.createElement('section');
        group.className='ml-product__detail-section';
        if(index++===0)group.classList.add('ml-product__detail-section--intro');
        description.append(group);
      }
      if(group)group.append(node);
    }
    description.querySelectorAll('.ml-product__detail-section').forEach(section=>{
      if(section.querySelector(':scope > details'))section.classList.add('ml-product__detail-section--faq');
      if(section.querySelector('table,ul,ol,img,details'))section.classList.remove('ml-product__detail-section--intro');
    });
    description.querySelectorAll('table').forEach(table=>{
      const row=table.rows[0];
      if(row)table.dataset.columns=String([...row.cells].reduce((count,cell)=>count+cell.colSpan,0));
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>minglangArrangeProductDetails());
else minglangArrangeProductDetails();
document.addEventListener('shopify:section:load',event=>minglangArrangeProductDetails(event.target));

document.addEventListener('click',e=>{const a=e.target.closest('[data-open-enquiry]');if(a){const target=document.querySelector(a.getAttribute('href'));const detail=target&&target.closest('details');if(detail)detail.open=true;}});
document.addEventListener('click',e=>{const thumb=e.target.closest('[data-product-thumb]');if(thumb){const scope=thumb.closest('[data-product-section]');scope.querySelectorAll('[data-product-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));scope.querySelectorAll('[data-product-photo]').forEach(p=>p.hidden=p.dataset.productPhoto!==thumb.dataset.productThumb);}const q=e.target.closest('[data-quantity-change]');if(q){const input=q.closest('form').elements.quantity;const min=Number(input.min)||1,max=Number(input.max)||999,step=Number(input.step)||1;input.value=String(Math.max(min,Math.min(max,Number(input.value||min)+Number(q.dataset.quantityChange)*step)));}});
document.addEventListener('change',e=>{if(!e.target.matches('[data-variant-select]'))return;const scope=e.target.closest('[data-product-section]'),v=JSON.parse(scope.querySelector('[data-product-variants]').textContent).find(v=>v.id===Number(e.target.value));if(!v)return;scope.querySelector('[data-product-price]').textContent=v.price;const b=scope.querySelector('[data-product-add]');b.disabled=!v.available;b.textContent=v.available?scope.dataset.addLabel:scope.dataset.unavailable;const qty=scope.querySelector('[name=quantity]');qty.min=v.min;qty.max=v.max;qty.step=v.step;qty.value=v.min;const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);});
document.addEventListener('submit',async e=>{if(!e.target.matches('[data-product-form]')||!window.MinglangMember)return;e.preventDefault();const f=e.target,scope=f.closest('[data-product-section]'),m=window.MinglangMember;const variant=f.elements.id.value,quantity=Number(f.elements.quantity.value);if(!f.reportValidity())return;if(!m.customer){const target=new URL(location.href);target.searchParams.set('variant',variant);m.handoff({action:'add',variant,quantity,target:target.pathname+target.search});return;}const b=f.querySelector('[data-product-add]');b.disabled=true;try{await m.add(variant,quantity);if(window.MinglangCart){await window.MinglangCart.open(b);b.disabled=false;}else location.assign(scope.dataset.cartUrl);}catch(error){scope.querySelector('[data-product-status]').textContent=error.message;b.disabled=false;}});

  } catch(e) { console.error(e); }
})();
})();
